import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faUserGear,
  faChalkboardUser,
  faFileExport,
  faTrashCan
} from '@fortawesome/free-solid-svg-icons';
import { faTrashCanUndo } from '@fortawesome/pro-solid-svg-icons';

const FloatingBar = ({
  selectedItems,
  onAction,
  activeTab,
  showRestore
}) => {

  const floatingMenu = [
    {
      id: 1,
      name: 'transfer_to_administrator',
      displayName: 'Transfer to Administrator',
      tooltip: 'Transfer to Administrator',
      icon: <FontAwesomeIcon icon={faUserGear} />,
      isMultiSelectEnabled: true,
      disabled: selectedItems.filter((set) => set.isDeleted).length > 0,
      modal: () => onAction('transfer_to_administrator'),
      setType: ['questionsets', 'resourcesets']
    },
    {
      id: 2,
      name: 'transfer_to_teacher',
      displayName: 'Transfer to Teacher',
      tooltip: 'Transfer to Teacher',
      icon: <FontAwesomeIcon icon={faChalkboardUser} />,
      isMultiSelectEnabled: true,
      disabled: selectedItems.filter((set) => set.isDeleted).length > 0,
      modal: () => onAction('transfer_to_teacher'),
      setType: ['questionsets', 'resourcesets']
    },
    {
      id: 3,
      name: 'export_to_xml_file',
      displayName: 'Export to XML file',
      tooltip: 'Export to XML file',
      icon: <FontAwesomeIcon icon={faFileExport} />,
      isMultiSelectEnabled: true,
      disabled: selectedItems.filter((set) => set.isDeleted).length > 0,
      modal: () => onAction('export_to_xml_file'),
      setType: ['questionsets']
    },
    {
      id: 4,
      name: showRestore && selectedItems.filter((set) => set.isDeleted).length > 0 ? 'restore' : 'delete',
      displayName: showRestore && selectedItems.filter((set) => set.isDeleted).length > 0 ? 'Restore Deleted' : 'Delete',
      tooltip: showRestore && selectedItems.filter((set) => set.isDeleted).length > 0 ? 'Restore Deleted' : 'Delete',
      icon: showRestore && selectedItems.filter((set) => set.isDeleted).length > 0 ? (
        <FontAwesomeIcon icon={faTrashCanUndo} />
      ) : (
        <FontAwesomeIcon icon={faTrashCan} />
      ),
      isMultiSelectEnabled: true,
      disabled: false,
      modal: () => onAction('delete'),
      setType: ['questionsets', 'resourcesets']
    },
  ];

  return (
    <div className='d-flex floating-menu justify-content-center'>
      <div className="floating-menu-in mr-2 w-60">
        {floatingMenu
          .filter(x => x.setType.includes(activeTab))
          .map((value, index) => (
            <OverlayTrigger
              key={`float-top-${index}`}
              placement="top"
              overlay={
                <Tooltip id={`tooltip-top-${value.id}`} className="custom-tooltip">
                  {value.tooltip}
                </Tooltip>
              }>
              <button
                key={`floating-Menu-btn-${index}`}
                id={`floating-menu-${value.id}`}
                className={value.disabled && 'disable-Pointer-Events'}
                onClick={() => value.modal(value.id)}
                disabled={value.disabled || (selectedItems.length == 0) || (selectedItems.length > 1 && !value.isMultiSelectEnabled)}
              >
                {value.icon}
                {value.displayName}
              </button>
            </OverlayTrigger>
          ))}
      </div>
    </div>
  );
};

FloatingBar.propTypes={
  selectedItems: PropTypes.array.isRequired,
  onAction: PropTypes.func.isRequired,
  activeTab: PropTypes.string,
  showRestore: PropTypes.bool
};

export default FloatingBar;